import { connect } from 'react-redux';

import BaseComponent from '../../components/BaseComponent';
import { clientsConfig } from '../../entity/clinets/clientsConfig';

class Clients extends BaseComponent {
  constructor(props) {
    super(props);
    this.config = { ...clientsConfig };
    this.getResponse();
  }
}
const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(Clients);
